import OregonCityPageTemplate from "@/pages/oregon-city/CityPageTemplate";
import { milwaukieConfig } from "./data";

export default function MilwaukiePage() {
  return <OregonCityPageTemplate config={milwaukieConfig} />;
}